import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, UrlSerializer, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {provideAnimations} from '@angular/platform-browser/animations';
import {TrailingSlashUrlSerializer} from "../util/TrailingSlashUrlSerializer";
import { headerInterceptor } from '../network/header/header.interceptor';
import { provideToastr } from 'ngx-toastr';
import { loadingInterceptor } from '../util/loading.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(
      routes,
      // scrollPositionRestoration: هر ناوبری از ابتدای صفحه شروع می‌شود
      // (و در back/forward موقعیت قبلی برمی‌گردد). پیش از این موقعیت اسکرول
      // صفحه قبل حفظ می‌شد و کاربر وسط صفحه جدید فرود می‌آمد
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled'
      })
    ),
    {provide: UrlSerializer, useClass: TrailingSlashUrlSerializer},
    provideClientHydration(),
    provideHttpClient(
      withFetch(),
      withInterceptors([headerInterceptor, loadingInterceptor])
    ),
    // provideNoopAnimations با provideAnimations تداخل داشت و انیمیشن ورود
    // دیالوگ‌ها نیمه‌کاره می‌ماند؛ نتیجه‌اش رندر دائمی روی scale(0.8) بود
    provideAnimations(), // برای افکت‌ها
    provideToastr({
     progressBar: true,
    }),
  ]
};
